import { AsyncPipe } from "@angular/common";
import { ChangeDetectionStrategy, Component, ViewChild } from "@angular/core";
import { AbstractControl, ReactiveFormsModule } from "@angular/forms";
import { FieldType, FormlyModule } from "@ngx-formly/core";
import { Message } from "primeng/message";
import { NewUiEditorComponent } from "../../shared/form/editor/new-ui-editor.component";
import { IsFilledByAIPipe, IsSuggestedPipe } from "../../shared/pipes/has-form-errors.pipe";

@Component({
  selector: "new-ui-formly-rich-text",
  templateUrl: "./new-ui-formly-rich-text.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    FormlyModule,
    Message,
    NewUiEditorComponent,
    IsSuggestedPipe,
    IsFilledByAIPipe,
    AsyncPipe,
  ],
})
export class NewUiFormlyRichTextComponent extends FieldType {
  @ViewChild(NewUiEditorComponent)
  protected newUiEditor: NewUiEditorComponent;

  protected getContentControl(): AbstractControl<string> {
    return this.form.get(this.props.contentControlName);
  }

  protected getDeltaControl(): AbstractControl {
    return this.form.get(this.props.deltaControlName);
  }
}
